/**
 * SyncResultAlert - Alert de resultado de sincronização
 */
import React from 'react';
import { Alert, Typography, Box, Chip } from '@mui/material';

const SyncResultAlert = ({ syncResult }) => {
    if (!syncResult) return null;

    return (
        <Alert severity="success" sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
                {syncResult.totalProcessed ? 'Importação de Audiência Concluída!' : 'Sincronização Concluída!'}
            </Typography>
            <Typography variant="body2">
                {syncResult.totalProcessed ? (
                    <>
                        <strong>Domínios processados:</strong> {syncResult.totalProcessed || 0}<br />
                        <strong>Domínios atualizados:</strong> {syncResult.updatedDomains || 0}<br />
                        <strong>Novos domínios criados:</strong> {syncResult.newDomains || 0}<br />
                        <strong>Pendentes concluídos:</strong> {syncResult.pendingCompleted || 0}<br />
                        <strong>Erros:</strong> {syncResult.errors || 0}
                    </>
                ) : (
                    <>
                        <strong>Artigos verificados:</strong> {syncResult.totalArticles || 0}<br />
                        <strong>Domínios únicos:</strong> {syncResult.uniqueDomains || 0}<br />
                        <strong>Já cadastrados:</strong> {syncResult.alreadyRegistered || 0}<br />
                        <strong>Já pendentes:</strong> {syncResult.alreadyPending || 0}<br />
                        <strong>Novos pendentes:</strong> {syncResult.newPending || 0}<br />
                        <strong>Erros:</strong> {syncResult.errors || 0}
                    </>
                )}
            </Typography>
            {syncResult.newDomainsList && syncResult.newDomainsList.length > 0 && (
                <Box mt={2}>
                    <Typography variant="subtitle2" gutterBottom>
                        Novos domínios criados:
                    </Typography>
                    {syncResult.newDomainsList.map((domain, index) => (
                        <Chip
                            key={index}
                            label={`${domain.siteName} (${domain.domain})`}
                            size="small"
                            color="primary"
                            sx={{ mr: 1, mb: 1 }}
                        />
                    ))}
                </Box>
            )}
            {syncResult.newDomains && syncResult.newDomains.length > 0 && !syncResult.newDomainsList && (
                <Box mt={2}>
                    <Typography variant="subtitle2" gutterBottom>
                        Novos domínios encontrados:
                    </Typography>
                    {syncResult.newDomains.map((domain, index) => (
                        <Chip
                            key={index}
                            label={`${domain.domain} (${domain.siteName})`}
                            size="small"
                            color="primary"
                            sx={{ mr: 1, mb: 1 }}
                        />
                    ))}
                </Box>
            )}
            {syncResult.errorsList && syncResult.errorsList.length > 0 && (
                <Box mt={2}>
                    <Typography variant="subtitle2" gutterBottom>
                        Domínios com erro:
                    </Typography>
                    {syncResult.errorsList.map((errorItem, index) => (
                        <Chip
                            key={index}
                            label={`${errorItem.domain} - ${errorItem.error}`}
                            size="small"
                            color="error"
                            sx={{ mr: 1, mb: 1 }}
                        />
                    ))}
                </Box>
            )}
        </Alert>
    );
};

export default SyncResultAlert;
